import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AILibraryComponent } from './ai-library/ai-library.component';

import { AILibraryDetailsComponent } from './ai-library/e-library-details/ai-library-details.component';
import { ELibraryTileComponent } from './ai-library/e-library-details/ai-library-tile/ai-library-tile.component';
import { AILibraryListComponent } from './ai-library/e-library-details/ai-library-list/ai-library-list.component';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'app/shared/shared.module';

import { ValidationService } from '../form-validation/validation.service';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import {VgCoreModule} from '@videogular/ngx-videogular/core';
import {VgControlsModule} from '@videogular/ngx-videogular/controls';
import {VgOverlayPlayModule} from '@videogular/ngx-videogular/overlay-play';
import {VgBufferingModule} from '@videogular/ngx-videogular/buffering';
import { AILibraryDashboardComponent } from './ai-library/e-library-details/ai-library-dashboard/ai-library-dashboard.component';
import { AILibraryUploadComponent } from './ai-library/e-library-details/ai-library-upload/ai-library-upload.component';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { BaseChartDirective } from 'ng2-charts';
import { AngularEditorModule } from '@kolkov/angular-editor';
// import { NgxWatermarkModule } from 'ngx-watermark';
import { NewAiLibraryComponent } from './ai-library/new-ai-library/new-ai-library.component';
// import { ClipboardModule } from 'ngx-clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PageHeaderComponent } from '../page-header/page-header.component';
import { AssistBotService } from '../ai-assist/assist-bot.service';
import { AIlibraryRoutingModule } from './ai-library-routing.module';
import { AILibraryService } from './ai-library/ai-library.service';

@NgModule({ declarations: [AILibraryComponent, AILibraryDetailsComponent, ELibraryTileComponent, AILibraryListComponent, AILibraryDashboardComponent, AILibraryUploadComponent, NewAiLibraryComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AIlibraryRoutingModule,
        SharedModule,
        NgxDocViewerModule,
        VgControlsModule,
        VgCoreModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        // RoundProgressModule,
        // BaseChartDirective,
        AngularEditorModule,
        // NgxWatermarkModule,
        // ClipboardModule,
        DragDropModule], providers: [
        AILibraryService, ValidationService, AssistBotService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AIlibraryModule { }
